/**
 * Stateless Slider component. Used in SliderInput, but can also be used seperately.
 */

import React from "react";
import { observer } from "mobx-react";
import classNames from "classnames";

export enum SliderTheme {
  Light = "light",
  Dark = "dark",
}

export interface ISliderProps {
  value: number;
  minimum?: number;
  maximum?: number;
  onChange: (newValue: number) => void;
  /**
   * Theme of the slider; defaults
   * to a light theme.
   */
  theme?: SliderTheme;
  stepSize?: number;
}

@observer
export default class Slider extends React.Component<ISliderProps> {
  public static defaultProps = {
    minimum: 0,
    maximum: 100,
    theme: SliderTheme.Light,
    stepSize: 1,
  };

  constructor(props: ISliderProps) {
    super(props);
  }

  public render(): JSX.Element {
    const { value, minimum, maximum, theme, stepSize } = this.props;
    return (
      <div className="center-aligned" style={{ width: "100%" }}>
        <input
          className={classNames({
            "slider-input__range-input": true,
            "slider-input__range-input--dark": theme === SliderTheme.Dark,
          })}
          type="range"
          min={minimum}
          max={maximum}
          onChange={this.onInputChange}
          value={value}
          step={stepSize}
        />
      </div>
    );
  }

  private onInputChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const inputValue = Number(event.target.value);
    if (isNaN(inputValue) || this.isBelowMin(inputValue) || this.isAboveMax(inputValue)) {
      return;
    } else {
      this.props.onChange(inputValue);
    }
  };

  private isBelowMin = (value: number) => {
    return this.props.minimum != undefined && value < this.props.minimum;
  };
  private isAboveMax = (value: number) => {
    return this.props.maximum != undefined && this.props.maximum < value;
  };
}
